import { cloneDeep } from "lodash";

const PUSH_GROUPS = "app/userGroups/PUSH_GROUPS";
const SET_DELETED_GROUPS = "app/userGroups/SET_DELETED_GROUPS";
const RESET_GROUPS = "app/userGroups/RESET_GROUPS";
const SET_LOADING = "app/userGroups/SET_LOADING";
const SET_REFRESH = "app/userGroups/SET_REFRESH";
const SET_ERROR = "app/userGroups/SET_ERROR";

const initialState = {
  groups: [],
  deletedGroups: [], // to remove them from selected
  loading: false,
  refresh: false,
  error: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PUSH_GROUPS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        groups: action.payload
      };
    }

    case SET_DELETED_GROUPS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        deletedGroups: action.payload
      };
    }

    case RESET_GROUPS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        groups: null
      };
    }

    case SET_REFRESH: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        refresh: action.payload
      };
    }

    case SET_LOADING: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        loading: action.payload
      };
    }

    case SET_ERROR: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        error: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export const pushGroups = (groups) => ({ type: PUSH_GROUPS, payload: groups });

export const setDeletedGroups = (groups) => ({ type: SET_DELETED_GROUPS, payload: groups });

export const clearDeletedGroups = () => ({ type: SET_DELETED_GROUPS, payload: [] });

export const resetGroups = () => ({ type: RESET_GROUPS });

export const setLoading = (loading) => ({ type: SET_LOADING, payload: loading });

export const setRefresh = (refresh) => ({ type: SET_REFRESH, payload: refresh });

export const setError = (error) => ({ type: SET_ERROR, payload: error });
